import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cms-video-player"
}
const _hoisted_2 = {
  controls: "",
  style: {"width":"100%"}
}
const _hoisted_3 = ["src"]

import { debug as d } from "debug";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-video-player',
  props: {
    mediaSource: {}
  },
  setup(__props: any) {

const debug = d("cs.CmsVideoPlayerComponent");

const props = __props;

onMounted(() => {
  debug("Displaying video player", props.mediaSource);
});

return (_ctx: any,_cache: any) => {
  return (_ctx.mediaSource)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("video", _hoisted_2, [
          _createElementVNode("source", {
            style: {"width":"100%","max-height":"calc(100vh - 50px - 50px)"},
            type: "video/mp4",
            src: _ctx.mediaSource
          }, null, 8, _hoisted_3)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})